module.exports = __webpack_public_path__ + "static/media/jamie-sparker-movie.7f0d1943.png";